import { API } from '@config';
import { ContactUsTransmissionDistributionTable } from '@src/types/ContactUsTransmissionDistribution';

export const getTransmissionDistribution = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/contact-us-transmission-distributions?populate=File&sort=id%3Adesc`, options);
  const data: ContactUsTransmissionDistributionTable = await response.json();

  return data;
};
